import { Component, EventEmitter, Input, OnInit, Optional, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { UnifiedAuthService } from '../../../services/unified-auth.service';
import { MatDialog } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { UserLoginResponse } from '../../../services/responses/pessoa.response';
import { DefaultColorEnum } from '../../../enum/default-color.enum';
import { PushNotificationService, Notificacao } from '../../../services/push-notification.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-action-notification',
    imports: [
        MatButtonModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatProgressSpinnerModule,
        MatIconModule,
        MatTooltipModule,
    ],
    templateUrl: './action-notification.component.html',
    styleUrl: './action-notification.component.css'
})
export class ActionNotificationComponent implements OnInit {
  private isAdminContext: boolean = false;

  constructor(
    private authService: UnifiedAuthService,
    @Optional() private pushService: PushNotificationService,
    @Optional() private router: Router,
    public dialog: MatDialog,) {
  }

  @Input() showActionNotification: boolean;
  @Input() areThereNotifications: boolean;

  @Output() showActionNotificationFalse = new EventEmitter<number>()
  @Output() setAreThereNotifications = new EventEmitter<boolean>()
  public color: string = DefaultColorEnum.Cor;
  public userLoginResponse: UserLoginResponse;
  public listNotificacoes: Notificacao[] = [];
  private subscriptions: Subscription = new Subscription();

  ngOnInit(): void {
    this.isAdminContext = this.router?.url?.startsWith('/admin') ||
      (typeof window !== 'undefined' && window.location.hostname.startsWith('admin.'));

    this.userLoginResponse = this.authService.getUserInfos();
    if (this.userLoginResponse?.empresaLogada?.preferenciaEmpresaStruct?.corHex) {
      this.color = this.userLoginResponse.empresaLogada.preferenciaEmpresaStruct.corHex;
      this.changeColor();
    }

    if (this.pushService) {
      this.subscriptions.add(
        this.pushService.notifications$.subscribe(data => {
          this.listNotificacoes = data;
          this.setAreThereNotifications.emit(data.some(x => !x.lido));
        })
      );

      this.pushService.refreshHistory();
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  clickContainerOut() {
    this.showActionNotificationFalse.emit();
  }

  clickLogout() {
    this.authService.logout();
  }

  changeColor() {
    document.documentElement.style.setProperty('--main-color', this.color);
  }

  clickNotificacao(notificacao: Notificacao) {
    if (!notificacao.lido) {
      this.pushService.markAsRead(notificacao.idNotificacao);
    }

    if (notificacao.rota) {
      // navigateByUrl: a rota de tickets carrega ?ticket=N; navigate([rota]) codificaria o "?".
      this.router.navigateByUrl(this.normalizarRota(notificacao.rota));
      this.clickContainerOut();
    }
  }

  /**
   * Os produtores do ERP gravam rotas com barra final ("/venda/pedidos/"). O navigate([rota]) antigo
   * descartava o segmento vazio; o navigateByUrl não — sem a barra removida a rota cai no "**" (Home).
   * Só o caminho é tocado: query string e fragmento seguem intactos.
   */
  private normalizarRota(rota: string): string {
    const corte = rota.search(/[?#]/);
    const caminho = corte === -1 ? rota : rota.slice(0, corte);
    const resto = corte === -1 ? '' : rota.slice(corte);
    return (caminho.replace(/\/+$/, '') || '/') + resto;
  }

  clickMarkAllAsRead() {
    this.pushService.markAllAsRead();
  }

}

